
const defaultError={
    error:{
        message:'I got something undefined errors',
        status_code:500
    }
}
const onError = err=>{
    return (err.response!==null&&err.response!==undefined)?
    {...err.response.data}:
    {...defaultError};
}
export default onError;